import { useContext } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { MessageContext } from '@/helpers/MessageProvider';

const useGimbalCommand = () => {
  const { publishCommand } = useContext(MessageContext);

  const reset = (mode) => (robot) => {
    const tid = uuidv4();
    const bid = uuidv4();

    const execute = () => publishCommand(robot, 'camera/gimbal', [tid, bid, Date.now(), mode]);

    return {
      execute,
      topic: `${robot.id}/telemetry/gimbal_reset`,
      isMatch: (data) => data.tid === tid && data.bid === bid,
      isSuccess: ({ data }) => data.result === 0,
    };
  };

  return {
    reset,
  };
};

export default useGimbalCommand;
